import { render, staticRenderFns } from "./CreateButton.vue?vue&type=template&id=55bca48c"
import script from "./CreateButton.vue?vue&type=script&lang=js"
export * from "./CreateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55bca48c')) {
      api.createRecord('55bca48c', component.options)
    } else {
      api.reload('55bca48c', component.options)
    }
    module.hot.accept("./CreateButton.vue?vue&type=template&id=55bca48c", function () {
      api.rerender('55bca48c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/CompanySwitcher/CreateButton.vue"
export default component.exports